module.exports = __webpack_public_path__ + "./fonts/Nvf.cf4e88453bc90954d90aaf632fe1bf86.svg";